export const BRAND = {
    name: 'Indian Industrial Distributors',
    short: 'IID',
    tagline: 'Decades of trust & uncompromised quality',
    established: 'EST. 1985',
    location: 'Wagle Industrial Estate, Thane 400604, Maharashtra, India',
    addressLine1: 'Plot No. D8, Jai Bhavani Nagar',
    addressLine2: 'Opp Meyer Research Centre, next to Hanuman Mandir',
    addressLine3: 'Wagle Industrial Estate, Thane 400604, Maharashtra, India',
    phones: ['+91 98210 31222', '+91 77188 45080'],
    emails: ['iidparag@gmail.com', 'Aryanagarwal004@gmail.com'],
};

export const NAV_LINKS = [
    { id: 'work', label: '01 · Work', href: '#work' },
    { id: 'products', label: '02 · Products', href: '#products' },
    { id: 'process', label: '03 · Process', href: '#process' },
    { id: 'quality', label: '04 · Quality', href: '#quality' },
    { id: 'contact', label: '05 · Contact', href: '#contact' },
];

export const CHAPTERS = [
    {
        num: '01',
        title: 'A foundry of trust, forged by decades',
        body: 'For four decades, Indian Industrial Distributors has been the quiet backbone behind India\'s most demanding engineering programs. We do not chase trends. We chase tolerance, finish, and repeatability — the traits that separate a component from a compromise.',
        overline: 'ABOUT / 01',
    },
    {
        num: '02',
        title: 'Bright bars, engineered for precision',
        body: 'Our specialty is precision bright bars — cold drawn, peeled, ground and polished to metric and imperial standards. Every bar is straightened, chamfered, inspected and tagged. Every batch carries its own paper trail.',
        overline: 'WHAT WE DO / 02',
    },
    {
        num: '03',
        title: 'Values that outlast the material',
        body: 'Consistency over speed. Traceability over hearsay. Long relationships over transactions. We build partnerships that hold up under load — mechanically and commercially.',
        overline: 'VALUES / 03',
    },
];

export const GRADE_PORTFOLIO = [
    '17Cr3', 'EN8D', 'EN8', 'EN32C', 'EN353',
    'SAE 8620', 'SAE 4140', '1018', '42CrMo4',
    '16MnCr6', '20MnCr5', 'AISI O1', 'SCM420 / 420H',
];

export const PRODUCTS = [
    {
        code: 'BB · RND',
        name: 'Round Bright Bars',
        sizeRange: 'Ø 4 mm – Ø 100 mm',
        tolerance: 'h8 / h9 / h10 / h11',
        grades: ['17Cr3', 'EN8D', 'EN8', 'EN32C', 'EN353', 'SAE 8620', 'SAE 4140', '1018', '42CrMo4', '16MnCr6', '20MnCr5', 'AISI O1', 'SCM420 / 420H'],
        finish: 'Cold Drawn · Turned · Ground · Polished',
    },
    {
        code: 'BB · HEX',
        name: 'Hexagonal Bright Bars',
        sizeRange: 'AF 6 mm – AF 65 mm',
        tolerance: 'h9 / h11',
        grades: ['EN8D', 'EN8', '1018', 'SAE 8620', '16MnCr6', '20MnCr5'],
        finish: 'Cold Drawn · Precision Peeled',
    },
    {
        code: 'BB · SQR',
        name: 'Square Bright Bars',
        sizeRange: '6 mm – 60 mm',
        tolerance: 'h11',
        grades: ['EN8D', 'EN8', '1018', '42CrMo4', 'SAE 4140', '16MnCr6'],
        finish: 'Cold Drawn · Straightened · Chamfered',
    },
    {
        code: 'BB · FLT',
        name: 'Flat Bright Bars',
        sizeRange: '10 × 3 mm – 100 × 25 mm',
        tolerance: 'h11 / k12',
        grades: ['EN8D', 'EN8', '1018', 'EN32C', '42CrMo4'],
        finish: 'Cold Drawn · Milled Edges',
    },
];

// Client / OEM wordmarks — representative Indian industrial OEMs commonly
// served by bright bar suppliers. Replace with the real client list when
// available. Data structure keeps a display label + a size class so the
// marquee reads as a genuine logo wall.
export const CLIENT_LOGOS = [
    { name: 'Tata', sub: 'Group' },
    { name: 'Mahindra', sub: 'Auto' },
    { name: 'Bajaj', sub: 'Auto' },
    { name: 'Ashok Leyland', sub: '' },
    { name: 'TVS', sub: 'Motor' },
    { name: 'L&T', sub: 'Heavy Eng.' },
    { name: 'Kirloskar', sub: 'Pumps' },
    { name: 'Sundram', sub: 'Fasteners' },
    { name: 'Hero', sub: 'MotoCorp' },
    { name: 'Endurance', sub: 'Technologies' },
    { name: 'Bharat Forge', sub: '' },
    { name: 'JBM', sub: 'Group' },
];

export const CERTS = [
    { code: 'ISO 9001:2015', label: 'Quality Management' },
    { code: 'IATF 16949', label: 'Automotive Standard' },
    { code: 'BIS · IS 9550', label: 'Bright Steel Bars' },
    { code: 'MTC · EN 10204', label: 'Mill Test Certificates' },
    { code: 'REACH · RoHS', label: 'Compliance Ready' },
    { code: 'PED 2014/68/EU', label: 'Pressure Grade' },
];

export const INDUSTRIES = [
    'Automotive', 'Fasteners', 'Hydraulics', 'Pumps & Valves',
    'Aerospace Components', 'Defence', 'Textile Machinery', 'Precision Shafts',
    'General Engineering', 'Oil & Gas',
];

export const PROCESS_STEPS = [
    { n: '01', title: 'Raw Material', body: 'Sourced from integrated steel plants with heat-wise traceability.' },
    { n: '02', title: 'Shot Blasting', body: 'In-house shot blasting removes scale and prepares the surface for downstream operations.' },
    { n: '03', title: 'Drawing', body: 'Cold drawing through tungsten carbide dies for dimensional precision and superior surface.' },
    { n: '04', title: 'Peeling', body: 'Precision peeling on CNC bar peelers — removes decarburised layers for h9 tolerance stock.' },
    { n: '05', title: 'Grinding', body: 'Centreless grinding delivers h8 tolerance and mirror-grade surface finish.' },
    { n: '06', title: 'Straightening & Inspection', body: 'Multi-roll straightening, 100% dimensional, ultrasonic and eddy-current testing before tagging.' },
];

export const FACILITY = {
    // Wide shop floor with A. V. Cranes overhead gantry — cinematic hero shot
    hero: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_bright-steel-pro/artifacts/5xlkjrxy_IMG_2877.jpeg',
    shopFloor: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_bright-steel-pro/artifacts/5xlkjrxy_IMG_2877.jpeg',
    // Stacked finished bright bars in foreground with production line behind
    bars: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_bright-steel-pro/artifacts/4d8fj5pw_IMG_2874.jpeg',
    // Long draw bench with bars being processed
    drawBench: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_bright-steel-pro/artifacts/wh2vp95l_IMG_2872.jpeg',
    // Drawing / straightening machine line
    machines: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_bright-steel-pro/artifacts/cwfls3eq_IMG_2876.jpeg',
    // Plant wide with lathes and machinery
    plantWide: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_bright-steel-pro/artifacts/zswtj34e_IMG_2875.jpeg',
};

export const GALLERY = [
    { url: FACILITY.hero, label: 'A. V. CRANES · MAIN BAY' },
    { url: FACILITY.bars, label: 'FINISHED BRIGHT BARS' },
    { url: FACILITY.drawBench, label: 'DRAW BENCH · IN PROCESS' },
    { url: FACILITY.machines, label: 'DRAWING LINE' },
    { url: FACILITY.plantWide, label: 'SHOP FLOOR · WIDE' },
];

export const STATS = [
    { k: '40+', v: 'Years serving industry' },
    { k: '100+', v: 'Active OEM partners' },
    { k: '5,000', v: 'MT annual throughput' },
    { k: '99.4%', v: 'On-spec delivery rate' },
];
